<script setup lang="ts">
  import { MpLoadingContainer, MpText } from '@borg/ui';

  const route = useRoute();

  const tag = computed(() => route.query.tag as string);
  const category = computed(() => route.query.category as string);
  const query = computed(() => route.query.query as string);

  const { data: articles, pending } = await articlesSearchRepository.getMany({
    tag,
    category,
    query,
  });
</script>

<template>
  <div class="mp-articles">
    <main>
      <MpText
        type="h2"
        class="mp-articles__title"
      >
        #{{ decodeURI(tag ?? category ?? '') }}
      </MpText>
      <MpLoadingContainer
        :is-loading="pending"
        :has-error="!articles || articles.length === 0"
      >
        <ArticleList
          :articles="articles ?? []"
          :columns="2"
        />
      </MpLoadingContainer>
    </main>
    <aside>
      <TopicsAndArticles />
    </aside>
  </div>
</template>

<style scoped lang="scss">
  .mp-articles {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-70);

    &__title {
      margin-bottom: var(--mp-space-60);
    }

    main {
      display: flex;
      flex-direction: column;
    }

    aside {
      border: 1px solid var(--mp-color-border-c-10);
      border-radius: 15px;
      padding: var(--mp-space-70);
      height: 100%;
    }

    @include screen-md {
      flex-direction: row;
      main {
        width: 46rem;
      }
      aside {
        width: 22rem;
      }
    }
  }
</style>
